import { useState } from "react";
import CardTemplate from "components/card/card-template/CardTemplate";
import { InvitationCodeForm } from "components/card/invitation-code/InvitationCodeForm";
import { InvitationCodeType } from "types/InvitationCodeTypes";
import WhereInvitationCodeModal from "components/modal/where-invitation-code/WhereInvitationCodeModal";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";

type InvitationCodeCardProps = {
    onSubmit: (invitationCode: string) => void;
    isLoading?: boolean;
    error?: string | null;
};

const InvitationCodeCard = ({ onSubmit, isLoading = false, error: apiError }: InvitationCodeCardProps) => {
    const [error, setError] = useState(false);
    const [errorType, setErrorType] = useState<InvitationCodeType>("invalidCode");

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);
        const invitationCode = formData.get("invitationCode") as string;

        setError(false);

        if (!invitationCode || invitationCode.trim() === "") {
            setError(true);
            setErrorType("minCharacters");

            pushGTMEvent(GA_EVENT_CONFIGS.INVITATION_EMPTY_CODE);
            return;
        }

        if (invitationCode.length !== 10) {
            setError(true);
            setErrorType("minCharacters");

            pushGTMEvent(GA_EVENT_CONFIGS.INVITATION_INVALID_LENGTH);
            return;
        }

        onSubmit(invitationCode.toUpperCase());
    };

    const handleInputChange = () => {
        if (error) {
            setError(false);
        }
    };

    return (
        <CardTemplate title="Enter Your Invitation Code" className="text-base-content min-h-[308px] tablet:min-h-[308px]">
            <form onSubmit={handleSubmit} data-testid="invitation-code-form">
                <div data-testid="welcome-back-content" className="font-medium text-base-content text-base flex flex-col gap-4">
                    <p className="text-sm leading-5 tracking-sm text-base-content pr-2 font-medium">
                        Please enter the 10-character invitation code found on the offer you received in the mail.
                    </p>

                    <WhereInvitationCodeModal />

                    <InvitationCodeForm
                        error={error || !!apiError}
                        errorType={apiError ? "invalidCode" : errorType}
                        onInputChange={handleInputChange}
                    />

                    <div className="flex justify-center w-full">
                        <button
                            type="submit"
                            className={`${
                                isLoading ? "pointer-events-none cursor-not-allowed" : ""
                            } btn bg-secondary-content font-semibold flex text-sm text-secondary border-none rounded hover:bg-secondary-content/80 min-h-0 h-[36px] px-6`}
                        >
                            Get Started{" "}
                            {isLoading && <span data-testid="loading-spinner" className="loading loading-spinner loading-sm" />}
                        </button>
                    </div>
                </div>
            </form>
        </CardTemplate>
    );
};

export default InvitationCodeCard;
